/** Curated homepage editorial picks — canvas originals only on the luxury homepage. */
export type HomepageEditorialPick = { medium: "canvas"; id: string };

export const homepageEditorialPicks = [
  { medium: "canvas", id: "sissi-with-a-pearl-earring" },
  { medium: "canvas", id: "conversation-on-mars" },
  { medium: "canvas", id: "giraffe" },
  { medium: "canvas", id: "hope-between-garbage-cans" },
  { medium: "canvas", id: "dan-schachter-tribute" },
] as const satisfies readonly HomepageEditorialPick[];

/** @deprecated Use homepageEditorialPicks for the homepage. Kept for campaign / legacy refs. */
export const homepageFeaturedByMedium = {
  canvas: ["lion", "sissi-with-a-pearl-earring", "tahdig"],
  ai: [
    "the-near-future-of-hungru",
    "butter-flavour-spirit-taste-identity-demo-hungru",
    "havah-project-cover-the-women-health-app-havah",
  ],
  digital: [
    "ad97da46-92e0-4bf7-87fa-37b1e01e877c",
    "2bf5fe3b-86d0-40ed-8e7c-c0c9bfd269ab",
    "edb2ef43-1330-41cc-9070-15aa1d0a178e",
  ],
} as const;

export const homepageCanvasIds = homepageFeaturedByMedium.canvas;
export const homepageAiIds = homepageFeaturedByMedium.ai;
export const homepageDigitalIds = homepageFeaturedByMedium.digital;

export const campaignPicks = {
  hungru: [
    "hungru-960s-call-for-food-critiques",
    "hungru-vibrant-call-for-food-critiques",
    "butter-flavour-spirit-taste-identity-demo-hungru",
    "wine-woman-human-taste-identity-demo",
  ],
  havah: [
    "havah-project-cover-the-women-health-app-havah",
    "game-board7-havah",
    "heaven-goal-havah",
    "hormonic-periods-of-the-month-woman-health",
  ],
} as const;

/** About page — canvas originals in situ / studio highlights (luxury sales path). */
export const aboutCanvasFeaturedIds = [
  "sissi-with-a-pearl-earring",
  "giraffe",
  "tikva-shuk",
  "hippo",
] as const;

/** @deprecated AI grid removed from About; kept for Full Gallery / legacy refs. */
export const aboutAiFeaturedIds = [
  "the-near-future-of-hungru",
  "butter-flavour-spirit-taste-identity-demo-hungru",
  "wine-woman-human-taste-identity-demo",
  "havah-project-cover-the-women-health-app-havah",
  "veshavu-action-figures1-realistic",
  "whales-couple-animals",
  "inspiration-flows",
  "pond-nice-quiet-place-to-meditate-to",
] as const;
